import {
  InsuranceCoverage,
  SpecialInsuranceCoverage,
} from "Store/interfaces/products/coverage";
import { useComponentTexts, useIpidLink } from "Store/texts/hooks";

import { DownloadButton } from "Components/DownloadButton";
import { isAkaGroupLifeTimeCoverage } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/DisabilityAdviceCard/Forms/utils";
import { isSopSicknessLeaveCoverage } from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/sopSicknessLeaveUtils";
import { isAkaFamilyAccidentCoverage } from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/akaFamilyAccidentUtils";
import { isAnimalCoverage } from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalUtils";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { buttonTrackId } from "Utils/analytics";
import React from "react";
import { IpidKeyType } from "./utils";

interface IpidListProps {
  readonly productName?: INSURANCE_NAME_VALUE;
  readonly coverage?: InsuranceCoverage;
  readonly specialCoverage?: SpecialInsuranceCoverage;
  readonly isOnColoredBackground?: boolean;
  readonly useShortText?: boolean;
}

export const IpidPdfButton = ({
  productName,
  specialCoverage,
  coverage,
  isOnColoredBackground,
  useShortText = false,
}: IpidListProps): React.ReactElement | null => {
  const [{ ipidPdfLink, ipidPdfLinkTextShort }, lang] = useComponentTexts();

  const ipidKey = specialCoverage ?? coverage ?? productName;

  const getIpidLinkKeyForProduct = (): IpidKeyType => {
    if (isAnimalCoverage(coverage)) {
      return INSURANCE_NAME_VALUE.ANIMAL;
    } else if (isAkaFamilyAccidentCoverage(coverage)) {
      return INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT;
    } else if (isSopSicknessLeaveCoverage(coverage)) {
      return INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE;
    } else if (isAkaGroupLifeTimeCoverage(coverage)) {
      return undefined;
    }
    return ipidKey;
  };

  const ipidLink = useIpidLink(getIpidLinkKeyForProduct());

  if (!ipidLink) {
    return null;
  }

  let linkTexts = ipidPdfLink.default;
  if (useShortText) {
    linkTexts = ipidPdfLinkTextShort;
  }
  if (specialCoverage) {
    linkTexts = ipidPdfLink[specialCoverage];
  }

  return (
    <DownloadButton
      link={ipidLink}
      text={linkTexts[lang]}
      className={buttonTrackId("download-insurance-ipid")}
      isOnColoredBackground={isOnColoredBackground}
    />
  );
};
